var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHomeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19648)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6895 12.7397C24.7996 11.9867 23.5004 11.9867 22.6105 12.7397C22.6025 12.7465 22.5943 12.7532 22.586 12.7598L13.1754 20.2683C12.5319 20.7688 12.2 21.4536 12.2 22.2V33.5C12.2 34.8925 13.3075 36 14.7 36H33.5C34.8747 36 36.0157 34.904 36.1 33.4703V22.2C36.1 21.4536 35.7681 20.7687 35.1247 20.2683L35.1139 20.2599L25.714 12.7598C25.7057 12.7532 25.6975 12.7465 25.6895 12.7397ZM27.0976 11.0494C25.3921 9.61685 22.9079 9.61685 21.2024 11.0494L11.819 18.5361C10.6659 19.4356 10 20.7487 10 22.2V33.5C10 36.1075 12.0925 38.2 14.7 38.2H33.5C36.1172 38.2 38.1709 36.1088 38.2986 33.5549C38.2995 33.5366 38.3 33.5183 38.3 33.5V22.2C38.3 20.7487 37.6341 19.4355 36.481 18.5361L27.0976 11.0494Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7111 29.2238C21.7075 29.2329 21.7 29.2567 21.7 29.3V36H26.5V29.3C26.5 29.2567 26.4925 29.2329 26.4889 29.2238C26.4869 29.219 26.4854 29.2164 26.4847 29.2153C26.4836 29.2146 26.481 29.2131 26.4762 29.2111C26.4671 29.2075 26.4433 29.2 26.4 29.2H21.8C21.7567 29.2 21.7329 29.2075 21.7238 29.2111C21.719 29.2131 21.7164 29.2146 21.7153 29.2153C21.7146 29.2164 21.7131 29.219 21.7111 29.2238ZM27.6 37.1H28.7V29.3C28.7 27.9925 27.7075 27 26.4 27H21.8C20.4925 27 19.5 27.9925 19.5 29.3V37.1C19.5 37.7075 19.9925 38.2 20.6 38.2H27.6V37.1Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2,
    height: 28.2,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeLight);
export default __webpack_public_path__ + "static/media/icon_home_light.71b54e26.svg";
export { ForwardRef as ReactComponent };